import {Menu} from "antd";
import {Link} from "react-router-dom";
import logo2 from "../Assets/logo-2.png";

export const TopMenu = () => {
  return(
    <Menu theme="light" mode="horizontal">
      <Menu.Item key="logo">
        <Link to="/">
          <img width={20} className="logo" src={logo2} alt="Logo-2" /> COVID-19Base
        </Link>
      </Menu.Item>
      <Menu.Item key="manual" style={{ marginLeft: 'auto' }}>
        <Link to="/manual">
          Manual
        </Link>
      </Menu.Item>
      <Menu.Item key="credits">
        <Link to="/credits">
          Credits
        </Link>
      </Menu.Item>
    </Menu>
  )
}